// Generated by https://quicktype.io

export class FocusPayPaymentMethods {
	paymentMethods: PaymentMethod[];

	public constructor(init?: Partial<FocusPayPaymentMethods>) {
		Object.assign(this, init);
	}
}

export interface PaymentMethod {
	brands?: string[];
	name: string;
	type: string;
}
